import axios, { AxiosError, AxiosRequestConfig } from 'axios';
// const baseUrl = process.env.NODE_ENV === 'development' ? 'http://localhost:54210/Execute/' : 'Execute/';
const baseUrl = 'https://brumunddal-legesenter-client.azurewebsites.net/Execute/';

interface IErrorBase {
  error: Error | AxiosError;
  type: 'axios-error' | 'stock-error';
}

interface IAxiosError extends IErrorBase {
  error: AxiosError;
  type: 'axios-error';
}
interface IStockError extends IErrorBase {
  error: Error;
  type: 'stock-error';
}

export function axiosErrorHandler(
  callback: (err: IAxiosError | IStockError) => void
) {
  return (error: Error | AxiosError) => {
    if (axios.isAxiosError(error)) {
      callback({
        error: error,
        type: 'axios-error'
      });
    } else {
      callback({
        error: error,
        type: 'stock-error'
      });
    }
  };
}

class HttpClient {
  public execute<T>(requestName: string, body: any): Promise<T> {
    const opts: AxiosRequestConfig = {
      headers: { "x-client-id": "superdupersecretshouldbeinhere" }
    };
    return axios.post(baseUrl + requestName, body, opts).then((res) => {
      return res.data;
    }).catch(axiosErrorHandler(res => {
      if (res.type === 'axios-error') {
        throw new HttpError(res.error?.message, res.error?.response?.status);
      } else {
        throw new HttpError("Unknown error", 500);
      }
    })
    );
  }
}

class HttpError {
  message: string;
  code: string;
  constructor(msg: string, code: any) {
    this.message = msg ? msg : "An unknown error occured";
    this.code = code;
  }
}

const client = new HttpClient();
export { client as HttpClient, HttpError };